$ = require 'jquery'
Auth = require 'db/auth'
ChangeSetPasswordPopoverView = require 'views/member/change-set-password-popover-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
WarningBannerView = require 'views/header/warning-banner-view'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class SetPasswordBannerView extends WarningBannerView
  initialize: ->
    @listenTo @model, 'change:loginTypes', =>
      @$el.toggle(!Auth.canLogIn())
      $(window).triggerHandler("resize")

  events:
    'click .js-change-password': 'changePassword'

  render: ->

    @$el.html(
      templates.fill(
        'header_warning_password',
        @model.toJSON()
      )
    )

    @

  changePassword: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$('.js-change-password')
      view: new ChangeSetPasswordPopoverView({ @model, @modelCache })
    track("Header", "Password Banner", "Open Change Password Menu")



// WEBPACK FOOTER //
// ./app/scripts/views/header/set-password-banner-view.coffee